/**
 * Defines an interface for saving and restoring layout container state.  All layout containers
 * should mix this in and supply their own method implementations.
 *
 * @module MW/layout/Restorable
 * @copyright Copyright 2014-2015 The MathWorks, Inc.
 */
define([
    "dojo/_base/declare"
], function (declare) {
    return declare([], {
        /**
         * Gets the container state
         *
         * @returns {Object} a state object
         * @abstract
         * @instance
         */
        getState: function () {
            return null;
        },

        /**
         * Sets the container state
         *
         * @param {Object} state a state object previously obtained by calling getState
         * @abstract
         * @instance
         */
        setState: function (state) {},

        /**
         * @returns {boolean} true if the container state is in the process of being restored
         * @abstract
         * @instance
         */
        isRestoringState: function () {return false;},

        /**
         * Terminates the state restoration process if it is in progress
         *
         * @abstract
         * @instance
         */
        endStateRestore: function() {}
    });
});
